import { createFileRoute } from '@tanstack/react-router'

import PageFolderDetail from '@/pages/PageFolderDetail'

export const Route = createFileRoute('/folder/$folderId')({
  component: PageFolderDetail
})
